import * as React from 'react'
import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cn } from '@core/utils'

const TabsTrigger = React.forwardRef<
    React.ElementRef<typeof TabsPrimitive.Trigger>,
    React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => (
    <TabsPrimitive.Trigger
        ref={ref}
        className={cn(
            'inline-flex h-[33px] items-center justify-center whitespace-nowrap border-b-[1.6px] border-transparent px-2 pb-2 !text-body-md-b text-semantic-content-inkLight ring-offset-solid-ink-3 first:pl-0 last:pr-0 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-semantic-content-ink focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:border-solid-ink-3 data-[state=active]:text-semantic-content-ink sm:!text-display-sm',
            className,
        )}
        {...props}
    />
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

export default TabsTrigger
